import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleOAuthCallback } from '../utils/handleOAuthCallback';

const CognitoCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const processCallback = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const error = urlParams.get('error');
      
      if (error) {
        console.error('OAuth error:', error);
        navigate('/login');
        return;
      }
      
      const result = await handleOAuthCallback();
      if (result.success) {
        navigate('/workspace');
      } else {
        navigate('/login');
      }
    };
    
    processCallback();
  }, [navigate]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '100vh',
      flexDirection: 'column'
    }}>
      <h2>🔄 Processing Authentication...</h2>
      <p>Please wait while we complete your login.</p>
    </div>
  );
};

export default CognitoCallback;
